<style src="./Icon.scss"  lang="scss"></style>
<script src="./Icon.js"></script>

<template>
	<!-- eslint-disable vue/no-v-html -->
	<span class="icon" v-html="icon" />
</template>